import { Footer as FooterComponent } from "frno-react";
import useLayout from "../hooks/useLayout";
import useLayoutStore, { Layout } from "../state/LayoutStore";

export default function Footer() {
  useLayout();
  const { layout }: { layout: Layout } = useLayoutStore();

  return layout.footer ? (
    <FooterComponent
      links={layout.footer.columns}
      social={layout.footer.social}
    />
  ) : null;
}
